import { BookAppointmentScreen } from '@/modules/property-details/BookAppointmentScreen';

export default function BookAppointmentRoute() {
    return <BookAppointmentScreen />;
}
